import React from 'react';

import { 
  FaMobileAlt, 
  FaLaptop, 
  FaTabletAlt, 
  FaHeadphones ,
  FaTshirt ,
  FaBorderAll
} from 'react-icons/fa';
import './Category.css';
function Category({category,setCategory}) {
  return (
    <div>
         <div className="categories">
      <h2 className="section-title">Categories</h2>
      <div className="category-list">
        
       <div className="category-card" onClick={()=>setCategory('All-Products')}>
          <FaBorderAll className="category-icon" />
          <span>All-Products</span>
        </div>

        <div className="category-card" onClick={()=>setCategory('Mobile')}>
          <FaMobileAlt className="category-icon" />
          <span>Mobiles</span>
        </div>
        <div className="category-card" onClick={()=>setCategory('Laptop')}>
          <FaLaptop className="category-icon" />
          <span>Laptops</span>
        </div>
        <div className="category-card" onClick={()=>setCategory('Tablet')}>
          <FaTabletAlt className="category-icon" />
          <span>Tablets</span>
        </div>
        <div className="category-card" onClick={()=>setCategory('Cloth')}>
          <FaTshirt  className="category-icon" />
          <span>Clothes</span>
        </div>
      </div>
    </div>
    </div>
  )
}

export default Category